import React from 'react';

import { FormSeparator } from '@/components/ui/FormSeparator';
import { OAUTH_PROVIDERS } from '@/features/auth/login/consts/oauth';
import type { Strategy } from '@/features/auth/login/types/login';

interface SocialButtonsProps {
  onLogin: (strategy: Strategy) => void;
  providers?: typeof OAUTH_PROVIDERS;
}

// TODO: Re-enable social login buttons once OAuth providers are configured
export const SocialButtons: React.FC<SocialButtonsProps> = ({ onLogin: _onLogin, providers = OAUTH_PROVIDERS }) => {
  return (
    <div className="py-6">
      <FormSeparator text="WITH" widthClass="w-32" />
      <div className="flex justify-center gap-3 py-6">
        {providers.map(({ name, icon }) => (
          <button
            key={name}
            type="button"
            disabled
            aria-label={`Sign in with ${name}`}
            className="border-border-100 flex h-20 w-20 cursor-not-allowed flex-col items-center justify-center gap-1 rounded-md border opacity-40 shadow-sm"
          >
            <img src={icon} alt={name} className="h-6 w-6" />
            <div className="text-typography-900/65">{name}</div>
          </button>
        ))}
      </div>
      <FormSeparator text="OR" widthClass="w-32" />
    </div>
  );
};
